<!-- Non Trustly Banner -->
<section class="home_banner_wrapper" *ngIf="isCountryAllowed === 2" [ngClass]="isUserLoggedIn ? 'loggedIn' : 'notloggedIn'">
    <div class="home_banner--bg home_banner--overlayBg">
      <div class="container">
        <div class="row">
          <div *ngIf="!isUserLoggedIn" class="col-sm-6 col-md-5 col-lg-4 col-xxxl-3 home_banner--leftContainer middleAlignBlock hidden-xs home_banner--radialBg">
            <div class="middleAlign" id="homeBannerRegWrap">
              <div class="homeBannerReg banner_index-top">
                <app-quick-register *ngIf="windowType === 'desktop'"></app-quick-register>
              </div>
            </div>
          </div>
          <div *ngIf="banners" [innerHtml]="banners.content | safeHtml"></div>
        </div>
      </div>
    </div>
  </section>
  
  <!-- Trustly Desktop Banner -->
  <section class="home_banner_wrapper trustly_desktop_banner" *ngIf="isCountryAllowed === 1 && windowType === 'desktop'" [ngClass]="isUserLoggedIn ? 'loggedIn' : 'notloggedIn'">
    <div class="home_banner--bg home_banner--overlayBg">
      <div class="container">
        <div class="row">
          <div *ngIf="!isUserLoggedIn" class="col-sm-6 col-md-5 col-lg-4 col-xxxl-3 home_banner--leftContainer middleAlignBlock home_banner--radialBg">
            <div class="middleAlign" id="homeBannerRegWrap">
              <div class="homeBannerReg banner_index-top">
                <div class="trustlyreg--form">
                  <app-trustly-reg-step-one [callingFrom]= "'banner'"></app-trustly-reg-step-one>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="banners" [innerHtml]="banners.content | safeHtml"></div>
        </div>
      </div>
    </div>
  </section>
  
  <!-- Trustly Mobile Banner -->
  <section class="home_banner_wrapper" *ngIf="isCountryAllowed === 1 && windowType === 'mobile'" [ngClass]="isUserLoggedIn ? 'loggedIn' : 'notloggedIn trustly_mobile_banner'">
    <div class="home_banner--bg home_banner--overlayBg">
      <div class="container">
        <div class="row">
          <div *ngIf="!isUserLoggedIn" class="col-sm-6 col-md-5 col-lg-4 col-xxxl-3 home_banner--leftContainer middleAlignBlock home_banner--radialBg">
            <div class="middleAlign" id="homeBannerRegWrap">
              <div class="homeBannerReg banner_index-top">
                <div class="trustlyreg--form">
                  <app-trustly-reg-step-one [callingFrom]= "'banner'"></app-trustly-reg-step-one>
                </div>
              </div>
            </div>
          </div>
          <ng-container *ngIf="isUserLoggedIn">
            <div *ngIf="banners" [innerHtml]="banners.content | safeHtml"></div>
          </ng-container>
        </div>
      </div>
    </div>
  </section>
  
  <!-- Banner loader -->
  <section class="home_banner_wrapper home_banner--skelton-loader" *ngIf="isCountryAllowed === 0">
    <div class="loader loader-large"></div>
  </section>
  